// src/data/videos.js
// Curated list of YouTube videos with per-video genre labels.
export const VIDEOS = [
  { id: "VWf4HWchQnw", genre: "Metal", title: "" },
  { id: "su5WlE_SD0I", genre: "Ambient Sewerslvt", title: "" },
  { id: "Lc_czcjlJS4", genre: "Indie", title: "" },
  { id: "FTk8z6ydZrE", genre: "Hip Hop", title: "" },
  { id: "Kq-1QrvOIeo", genre: "Calm", title: "" },
  { id: "L86tbBjkCOY", genre: "Tense", title: "" },
  { id: "GP6F0y3eU0Q", genre: "Old School", title: "" },
  { id: "B8-_ogy-eGE", genre: "New School", title: "" },
  { id: "bOMb-pExCR0", genre: "Hard Style", title: "" },
  { id: "wir1f7QM-ZM", genre: "JP Electronic", title: "" },
  { id: "xV7pk2Rn0Fs", genre: "Metal", title: "" },
  { id: "1N724Ccv1No", genre: "Indie Rock", title: "" },

  
  // add as many as you want…
];
